import DashboardLayout from "@vendor/examples/LayoutContainers/DashboardLayout";
import Loading from "@vendor/examples/loading";
import DashboardNavbar from "@vendor/examples/Navbars/DashboardNavbar";

import type { ReactNode } from "react";

export interface MainLayoutProps {
    /** 23 de los 24 call sites lo pasan; SupportPage no tiene estado de carga. */
    loading?: boolean;
    children?: ReactNode;
}

export const MainLayout = ({loading, children}: MainLayoutProps) => {
    return(
        <DashboardLayout>
            <Loading open={loading}/>
            <DashboardNavbar/>
            {children}
        </DashboardLayout>
    )
}
